var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<script type=\"text/javascript\" src=\"https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js\"></script> <div ng-hide=\"!isApplePayAvailable || !pay.data.getService.service.masterpass_enabled\"> <button class=\"apple-pay-btn\" type=\"button\" ng-disabled=\"isDisabled\" ng-class=\"{'disabled': isInvalid}\" ng-click=\"applePay()\"> <img src=\"" + require("../../../assets/images/applepay-icon.svg") + "\" alt=\"apple-pay-btn-icon\"> </button> </div>";
ngModule.run(["$templateCache",function(c){c.put("applePay/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/applePay/templates/index.html
 ** module id = 43
 ** module chunks = 1
 **/